@if (myUser) {
    <form action="" [formGroup]="userProfileForm">
        <section class="card">
            <h2>{{ 'myUserProfile.label' | translate }}</h2>
            <div class="inputGroup">
                <span class="label">{{ 'myUserProfile.email' | translate }}</span>
                <input type="email" [disabled]="true" [value]="myUser.email" />
            </div>

            <div class="inputGroup">
                <label for="firstName">{{ 'myUserProfile.firstName' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="userProfileForm" [controlPath]="'firstName'" />
                    <input type="text" id="firstName" [formControlName]="'firstName'" trimInput />
                </div>
            </div>

            <div class="inputGroup">
                <label for="lastName">{{ 'myUserProfile.lastName' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="userProfileForm" [controlPath]="'lastName'" />
                    <input type="text" id="lastName" [formControlName]="'lastName'" trimInput />
                </div>
            </div>

            @if (!myUser.isShiji) {
                <div class="inputGroup">
                    <span class="label">{{ 'myUserProfile.companyName' | translate }}</span>
                    <input type="text" [disabled]="true" [value]="supplierName" trimInput />
                </div>
                <div class="inputGroup">
                    <span class="label">{{ 'myUserProfile.userGroups' | translate }}</span>
                    <input type="text" [disabled]="true" [value]="userGroups" trimInput />
                </div>
            }

            <div class="inputGroup">
                <label>{{ 'myUserProfile.changePassword' | translate }}</label>
                <div class="value">
                    <button type="button" class="button primary small" (click)="changePassword()">
                        {{ 'myUserProfile.changePassword' | translate }}
                    </button>
                </div>
            </div>

            @if (notifications && notifications.length !== 0) {
                <div class="inputGroup">
                    <label>{{ 'myUserProfile.notifications.label' | translate }}</label>
                    <div class="checkboxWrapper rows" [formGroupName]="'notificationSettings'">
                        @for (notification of notifications; track notification.id) {
                            <div class="notificationWrapper" id="notificationSettings">
                                <input type="checkbox" id="{{ notification.id }}" [formControlName]="notification.id" />
                                <label class="noFixedWidth" for="{{ notification.id }}">
                                    {{ 'myUserProfile.notifications.' + notification.notificationType | translate }}
                                </label>
                            </div>
                        }
                    </div>
                </div>
            }
            <div class="buttonArea">
                <button
                    class="button primary"
                    type="submit"
                    id="saveProfile"
                    [title]="translate.instant('myUserProfile.saveChanges')"
                    (click)="saveChanges()"
                >
                    {{ 'myUserProfile.saveChanges' | translate }}
                </button>
                <button class="button" type="button" id="cancel" title="{{ 'myUserProfile.cancel' | translate }}" routerLink="/dashboard">
                    {{ 'myUserProfile.cancel' | translate }}
                </button>
            </div>
        </section>
    </form>
}
